export default {"src":"/_next/static/media/set.4f97d14b.svg","height":12,"width":12,"blurWidth":0,"blurHeight":0};